export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-out', {
    mounted(el: HTMLElement, binding: any) {
      el._clickOutHandler = (_event: Event) => {
        if (!(el === _event.target || el.contains(_event.target as Node))) {
          binding.value()
        }
      }
      document.addEventListener('click', el._clickOutHandler)
    },
    unmounted(el: HTMLElement) {
      if (el._clickOutHandler) {
        document.removeEventListener('click', el._clickOutHandler)
        delete el._clickOutHandler
      }
    },
  })
})

declare global {
  interface HTMLElement {
    _clickOutHandler?: (event: Event) => void
  }
}
